import { Avatar, Icon } from "prism-react";

export const WorkspaceIndication = ({
  workspace,
}: {
  workspace: {
    name: string;
    avatarUrl: string | null;
    id: string | null;
  };
  currentUser: { username: string; name: string; avatarUrl: string } | null;
}) => {
  const publicWorkspace = workspace.id === null;

  if (publicWorkspace) {
    return (
      <>
        <Icon size={4} type="eyeOpen" />{" "}
        <span style={{ marginLeft: "10px" }}>Public</span>
      </>
    );
  }

  return (
    <>
      <Avatar
        name={workspace.name}
        shape="block"
        size="xs"
        src={workspace.avatarUrl}
      />{" "}
      <span style={{ marginLeft: "10px" }}>{workspace.name}</span>
    </>
  );
};
